<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import {writable} from 'svelte/store';
  import editorStore from '../../editor.store';
  import {adjustZIndex} from '../../style-helpers';
  import type {EditorActiveComponent} from '../../types';
  let show = writable(false);
  let container: HTMLElement;
  let button: HTMLElement;
  let item: EditorActiveComponent;
  const unmount = editorStore.subscribe(store => {
    if (store.activeComponent == item) return;
    show.set(false);
    item = store.activeComponent;
  });

  const showFn = () => {
    show.update(s => {
      s = !s;
      return s;
    });
  };

  const layerUp = () => {
    if (!item) return;
    adjustZIndex(item as HTMLElement, 1);
  };

  const layerDown = () => {
    if (!item) return;
    adjustZIndex(item as HTMLElement, -1);
  };
</script>

<div
  bind:this={button}
  on:click={showFn}
  class="inline-block cursor-pointer rounded-lg p-2 text-gray-800 transition-all hover:bg-gray-100 hover:text-blue-600"
>
  <span class="fa-thin fa-circle-ellipsis"></span>
</div>
{#if $show}
  <div bind:this={container} class="popover rounded-md bg-white p-4 text-gray-700 shadow-md">
    <div class="popover-item" on:click={layerUp}>
      <span class="fa-solid fa-sort-up" /> Move one layer up
    </div>
    <div class="popover-item" on:click={layerDown}>
      <span class="fa-solid fa-sort-down" /> Move one layer down
    </div>
  </div>
{/if}

<style lang="postcss">
  .popover {
    position: absolute;
    bottom: -150px;
    right: -300px;
    width: 300px;
  }

  .popover-item {
    @apply flex cursor-pointer items-center rounded-md px-2 py-4 hover:bg-blue-50;
  }

  .popicon {
    @apply mr-2 inline-block;
    --ggs: 0.5;
  }
</style>
